import { __rest } from "tslib";
import React, { useMemo } from 'react';
import { BlockIdContext } from '../../../context/blockIdContext';
import { NavigationItemType } from '../../../models';
import SocialIcon from '../SocialIcon/SocialIcon';
import { GithubButton } from './components/GithubButton/GithubButton';
import { NavigationButton } from './components/NavigationButton/NavigationButton';
import { NavigationDropdown } from './components/NavigationDropdown/NavigationDropdown';
import { NavigationLink } from './components/NavigationLink/NavigationLink';
const ANALYTICS_ID = 'navigation';
//todo: add types support form component in map
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NavigationItemsMap = {
    [NavigationItemType.Button]: NavigationButton,
    [NavigationItemType.Social]: SocialIcon,
    [NavigationItemType.Dropdown]: NavigationDropdown,
    [NavigationItemType.Link]: NavigationLink,
    [NavigationItemType.GithubButton]: GithubButton,
};
const NavigationItem = React.forwardRef((_a, ref) => {
    var { data, className } = _a, props = __rest(_a, ["data", "className"]);
    const { type = NavigationItemType.Link } = data;
    const Component = NavigationItemsMap[type];
    const componentProps = useMemo(() => (Object.assign(Object.assign(Object.assign({ className }, data), props), { ref })), [className, data, props, ref]);
    return (React.createElement(BlockIdContext.Provider, { value: ANALYTICS_ID },
        React.createElement(Component, Object.assign({}, componentProps))));
});
NavigationItem.displayName = 'NavigationItem';
export default NavigationItem;
